<template>
  <div class="card-form">
    <form @submit.prevent="checkForm" class="card-form-wrapper">
      <H1>Reset Password</H1>
      <TextInput
        v-model="email"
        name="email"
        label="Email"
        type="email"
        :disabled="true"
        :error="errors['email']"
        @input="removeErrorMessage('email', $event)"
      />
      <TextInput
        v-model="password"
        name="password"
        label="Password"
        type="password"
        :error="errors['password']"
        @input="removeErrorMessage('password', $event)"
      />
      <TextInput
        v-model="confirmPassword"
        name="confirmPassword"
        label="Confirm Password"
        type="password"
        :error="errors['confirmPassword']"
        @input="removeErrorMessage('confirmPassword', $event)"
      />
      <p class="error" v-if="error">{{ error_message }}</p>
      <Button class="red">Reset</Button>
    </form>
  </div>
</template>

<script>
import { H1, TextInput, Button } from "../../style";
import { mapActions } from "vuex";
import { AUTH_RESET_PASSWORD, VERIFY_RESET_TOKEN } from "../../store/types";
import moment from "moment-timezone";
export default {
  name: "Reset",
  components: {
    H1,
    TextInput,
    Button
  },
  computed: {
    intentToChangePassword() {
      return this.password.length > 0 || this.confirmPassword.length > 0;
    },
    passwordContainsNumber() {
      return /\d/.test(this.password);
    },
    passwordIsLongEnough() {
      return this.password.length >= 8;
    }
  },
  data() {
    return {
      email: "",
      password: "",
      confirmPassword: "",
      timezone: moment.tz.guess(),
      errors: {
        email: "",
        password: "",
        confirmPassword: ""
      },
      error: false
    };
  },
  beforeMount() {
    const { token } = this.$route.params;
    let urlSearch = new URLSearchParams(window.location.search);
    let email = urlSearch.get("email");
    if ((token && token.trim().length) && (email && email.trim().length)) {
      this.verifyToken({
        data: {
          email: email,
          token: token
        }
      })
        .then(() => {
          this.email = email;
        })
        .catch(({ status }) => {
          if (status == 404) {
            this.$router.push("/404").catch();
          }
        });
    } else {
      this.$router.push("/404").catch();
    }
  },
  methods: {
    ...mapActions({
      reset: AUTH_RESET_PASSWORD,
      verifyToken: VERIFY_RESET_TOKEN
    }),
    checkForm() {
      let preventSubmit = false;

      if (this.email.trim().length == 0) {
        preventSubmit = true;
        this.errors["email"] = "Email is required";
      }

      if (this.password.trim().length == 0) {
        preventSubmit = true;
        this.errors["password"] = "Password is required";
      }

      if (this.confirmPassword.trim().length == 0) {
        preventSubmit = true;
        this.errors["confirmPassword"] = "Confirm Password is required";
      }

      if (this.intentToChangePassword) {
        if (
          (this.password.length > 0 || this.confirmPassword.length > 0) &&
          this.password !== this.confirmPassword
        ) {
          preventSubmit = true;
          this.errors["confirmPassword"] = "Passwords do not match";
        }
      }

      if (!preventSubmit) {
        this.submitForm();
      }
    },
    removeErrorMessage(field, value) {
      if (value.trim().length) {
        this.errors[field] = "";
      }
    },
    submitForm() {
      this.error = false;
      this.loading = true;
      this.errors = [];
      this.reset({
        token: this.$route.params.token,
        email: this.email,
        password: this.password,
        password_confirmation: this.confirmPassword,
        timezone: this.timezone
      })
        .then(() => {
          this.loading = false;
          this.$notify({
            type: "success",
            title: "Success",
            message: "Password updated"
          });
          this.$router.push("/dashboard").catch(() => {});
        })
        .catch(e => {
          const { data } = e;
          this.loading = false;
          if (data.errors) {
            let { errors } = data;
            for (let [key, value] of Object.entries(errors)) {
              if (key !== undefined) {
                value.forEach(message => {
                  this.errors.push(message);
                });
              }
            }
            this.password = "";
            this.confirm_password = "";
            return;
          }
          if (data.message) {
            this.error = true;
            this.error_message = data.message;
            this.password = "";
            this.confirm_password = "";
          }
        });
    }
  }
};
</script>